/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.options.rpc.PurchaseOptionsService
 */

export const AnonymousUserContextTypename = 'com.hubspot.purchase.options.models.rpc.context.AnonymousUserContext';
export const AssistedUserContextTypename = 'com.hubspot.purchase.options.models.rpc.context.AssistedUserContext';
export const TouchlessUserContextTypename = 'com.hubspot.purchase.options.models.rpc.context.TouchlessUserContext';
export const findAllPurchasableProductsRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findAllPurchasableProducts',
  auth: 'external',
  fingerprint: 'yhte8nw6hYWQw5mnJg9QhOqDBJXDb_F_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findIndependentPurchasableProductsRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findIndependentPurchasableProducts',
  auth: 'external',
  fingerprint: 'qVnmglq7GrvjzHd2oAbrfYPwVjMz_ejb',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findPurchaseOptionsRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findPurchaseOptions',
  auth: 'external',
  fingerprint: 'Cx8U03Br6mV4mV-kZTZ-8uqDBJXDb_F_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findPurchaseRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findPurchase',
  auth: 'external',
  fingerprint: 'cJIQyD8zLF4tngO5xAviIOqDBJXDb_F_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findPackagedQuantityPurchaseOptionsRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findPackagedQuantityPurchaseOptions',
  auth: 'external',
  fingerprint: 'QfEmv2JjyaQuo8espUIC4-qDBJXDb_F_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const findQuantityPackPricingTiersRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findQuantityPackPricingTiers',
  auth: 'external',
  fingerprint: 'a62P76Z75q005qP2vTYNNOqDBJXDb_F_',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};